import React from "react";
import {
  IAddUpdateCustomerPageProps,
  IAddUpdateCustomerPageState,
} from "../../../interfaces/Index";
import FormSectionLayout from "../../layouts/FormSectionLayout";
import TextField from "../../common/TextField/TextField";
import ButtonComponent from "../../common/Button/ButtonComponent";
import { Container, Row, Col } from "reactstrap";
import { Form } from "reactstrap";
import {
  getLongitudeAndLatitude,
  normalizeCustomerReqPayload,
  normalizeCustomerUpdateReqPayload,
} from "../../../normalizer/CustomerNormalizer";
import "./AddUpdateCustomerPage.scss";
import backarrow from "../../../assets/images/back_arrow.svg";
import {
  phoneNumberValidate,
  alphaNumericValidator,
  coordinateOnlyValidator,
  phoneNumberOnlyValidator,
  cnicNumberValidate,
  cnicNumberOnlyValidator,
  numberWithCommaAndDot,
} from "../../../utils/Validators";
import Toaster from "../../common/Toaster/Toaster";
import LoaderComponent from "../../common/Loader/Loader";
import { autoGeneratePassword } from "../../../utils/lib";
import HeadingText from "../../common/HeadingText/HeadingText";
import DropdownButton from "../../common/ButtonDropDown/ButtonDropDown";
import { numbersOnly } from "../../../utils/Validators";
import { isActivated } from "../../../config/constants";
import { StoreStatus } from "./../../../config/constants";
import Modal from "../../common/Modal/Modal";
import { AbilityContext } from "../../../config/Can";
import {
  getUserByPhoneNumberApiCall,
  updateUserPasswordApiCall,
} from "../../../redux/sources/CustomerSource";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";
import Switch from "components/common/Switch/Switch";

export const doUserAPIsearch = async (val: any) => {
  return await getUserByPhoneNumberApiCall(val);
};

export default class AddUpdateCustomerPage extends React.Component<
  IAddUpdateCustomerPageProps,
  IAddUpdateCustomerPageState
> {
  autoGeneratePassword: string;
  zoneId: any;
  isCustomerFound: boolean;
  userId: string;
  constructor(props: IAddUpdateCustomerPageProps) {
    super(props);
    this.autoGeneratePassword = autoGeneratePassword();
    this.zoneId = props.dummyZoneId || "";
    this.isCustomerFound = props.dummyIsCustomerFound ? true : false;
    this.userId = "";
    this.state = {
      customerName: props.customer ? props.customer.customerName || "" : "",
      phoneNumber: props.customer ? props.customer.customerPhone || "" : "",
      password: props.customer
        ? props.customer.password || ""
        : this.autoGeneratePassword,
      storeName: props.customer ? props.customer.customerStore || "" : "",
      coOrdinates: props.customer ? props.customer.coOrdinates || "" : "",
      address: props.customer ? props.customer.address || "" : "",
      status: props.customer
        ? props.customer.customerStatus === "ACTIVE"
          ? { isValid: true, text: props.customer.customerStatus }
          : { isValid: false, text: props.customer.customerStatus }
        : { isValid: false, text: "UNVERIFIED" },
      userStatus: props.customer
        ? props.customer.customerStatus === "ACTIVE"
          ? { isValid: true, text: props.customer.customerStatus }
          : { isValid: false, text: props.customer.customerStatus }
        : { isValid: false, text: "UNVERIFIED" },
      showOnApp: true,
      showPassword: false,
      cnicNumber: props.customer ? props.customer.cnicNumber || "" : "",
      verifyModal: false,
      searchText: props.searchText || "",
      isLoading: false,
      storeType: props.customer
        ? props.customer.storeType || { id: "", label: "", value: "" }
        : { id: "", label: "", value: "" },
      resetPasswordModal: false,
      incomeTaxStatus: props.customer ? props.customer.incomeTaxStatus : false,
      registrationType: props.customer
        ? props.customer.registrationType
        : false,
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    const {
      getCustomerDetailsNew,
      customer,
      isEdit,
      searchText,
      fetchStoreType,
    } = this.props;
    fetchStoreType();
    if (isEdit && customer && customer.userId) {
      const userId = customer.userId as string;
      getCustomerDetailsNew(userId);
    } else {
      try {
        const data: any = await doUserAPIsearch(searchText);

        if (data) {
          this.userId = data.id;
          this.isCustomerFound = true;

          this.setState({
            customerName: data.fullName,
            phoneNumber: data.phoneNumber,
            cnicNumber: data.nationalId,
          });
        }
      } catch (e) {
        this.setState({
          phoneNumber: searchText,
        });
      }
    }
  }

  shouldComponentUpdate(nextProps: IAddUpdateCustomerPageProps) {
    const { isCustomerAdded, isCustomerUpdated } = this.props;
    if (
      (nextProps.isCustomerAdded || nextProps.isCustomerUpdated) &&
      (isCustomerAdded !== nextProps.isCustomerAdded ||
        isCustomerUpdated !== nextProps.isCustomerUpdated)
    ) {
      // redirect back to Customer listing || refresh page
      nextProps.backButtonHandler(true);
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps: IAddUpdateCustomerPageProps) {
    const { iscustomerDetailsNewFetched, customerDetailsNew, isError, error } =
      this.props;
    if (
      iscustomerDetailsNewFetched &&
      iscustomerDetailsNewFetched !== prevProps.iscustomerDetailsNewFetched
    ) {
      // if (meta && meta.length > 1) {
      //   const storeCoordinates = `${meta[0].value}, ${meta[1].value}`;
      //   this.setState({
      //     coOrdinates: storeCoordinates,
      //   });
      // }
      if (customerDetailsNew && customerDetailsNew.nationalId) {
        this.setState({
          cnicNumber: customerDetailsNew.nationalId,
          customerName: customerDetailsNew.fullName,
        });
      } else {
        this.setState({
          customerName: customerDetailsNew.fullName,
        });
      }
    }
    if (isError && isError !== prevProps.isError) {
      alert((error! as any).errors);
      this.setState({
        isLoading: false,
      });
      this.handleToaster(true, (error! as any).errors);
    }
  }

  handleToaster = (e: any, message: any) => {
    this.setState({
      showToaster: true,
      toastMessage: message,
      catchError: e,
    });
  };

  handleSubmit = async (e: any) => {
    const {
      createCustomer,
      isEdit,
      updateCustomer,
      customer,
      createStore,
      fetchCustomersZoneApi,
      // meta,
    } = this.props;

    this.setState({
      isLoading: true,
    });
    const latitudeAndLongitude = getLongitudeAndLatitude(
      this.state.coOrdinates
    );

    const zoneResponse: any = await fetchCustomersZoneApi({
      latitude: latitudeAndLongitude.latitude,
      longitude: latitudeAndLongitude.longitude,
      customerType: this.state.storeType,
    });
    let partnerChannels = [];
    if (zoneResponse && zoneResponse.payload) {
      this.zoneId = zoneResponse.payload.zone?.id || "";
      partnerChannels = zoneResponse.payload.partnerChannels;
    }

    if (!zoneResponse.error) {
      if (isEdit) {
        const reqPayload = normalizeCustomerUpdateReqPayload(
          this.state,
          customer,
          this.zoneId,
          partnerChannels
          // meta
        );
        updateCustomer(reqPayload);
      } else {
        const reqPayload = normalizeCustomerReqPayload(
          this.state,
          this.zoneId,
          partnerChannels
        );
        if (this.isCustomerFound) {
          createStore(reqPayload, this.userId);
        } else if (!zoneResponse.error) {
          createCustomer(reqPayload);
        }
      }
    }
  };

  handleChange = (e: any) => {
    if (e.target.id === "status") {
      this.setState({
        [e.target.id]: !this.state[e.target.id],
      });
    } else if (e.target.id === "coOrdinates") {
      if (numberWithCommaAndDot.test(e.target.value)) {
        this.setState({
          [e.target.id]: e.target.value,
        });
      }
    } else {
      this.setState({
        [e.target.id]: e.target.value,
      });
    }
  };

  resetPasswordConfirmationModal = () => {
    this.setState({
      resetPasswordModal: !this.state.resetPasswordModal,
    });
  };

  resetPassword = () => {
    let userId: any = this.props.customer && this.props.customer.id;
    let passwordPayload = {
      password: this.autoGeneratePassword,
      passwordConfirmation: this.autoGeneratePassword,
    };
    if (
      this.props.isEdit &&
      (updateUserPasswordApiCall(userId, passwordPayload) as any)
    ) {
      this.resetPasswordConfirmationModal();
      this.props.backButtonHandler(true, "passwordResetSuccess");
    } else {
      this.props.backButtonHandler(false, "passwordResetUnsuccessful");
    }
  };

  handleSearchableSelect = (e: any, id: any) => {
    this.setState({
      [id]: e,
    });
  };

  storeStatusOnChange = (e: any, id: any) => {
    e.clickHandler();
  };

  selectedValue = (options: any, selectedVal: any) => {
    for (let i = 0; i < options.length; i++) {
      let option = options[i].label;
      let value = selectedVal && selectedVal;
      if (option === value) {
        return options[i];
      }
    }
  };

  handleCnic = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (numbersOnly(e.target.value)) {
      if (
        e.target.value.length > this.state.cnicNumber.length ||
        Math.abs(e.target.value.length - this.state.cnicNumber.length) > 1
      ) {
        const formattedCnic = this.formatCnicNumber(
          e.target.value.replace(/-/g, "")
        );
        this.setState({
          cnicNumber: formattedCnic,
        });
      } else {
        this.setState({
          cnicNumber: e.target.value,
        });
      }
    }
  };

  formatCnicNumber = (str: string) => {
    if (str.length >= 5) {
      if (str.length >= 12) {
        let firstPart = str.substring(0, 5);
        let secondPart = str.substring(5, str.length);
        firstPart += "-";
        let newFinal = firstPart + secondPart;
        firstPart = newFinal.substring(0, 13);
        firstPart += "-";
        secondPart = newFinal.substring(13, newFinal.length);
        return firstPart + secondPart;
      } else {
        let firstPart = str.substring(0, 5);
        let secondPart = str.substring(5, str.length);
        firstPart += "-";
        return firstPart + secondPart;
      }
    }
    return str;
  };

  handleGoBackButton = () => {
    const { clearCustomerDetailsNewAction, isEdit, backButtonHandler } =
      this.props;
    isEdit && clearCustomerDetailsNewAction();
    backButtonHandler(false);
  };

  deactivateAccount = () => {
    this.setState({
      status: {
        isValid: false,
        text: StoreStatus.INACTIVE,
      },
    });
  };

  suspendAccount = () => {
    this.setState({
      status: {
        isValid: false,
        text: StoreStatus.SUSPENDED,
      },
    });
  };

  unverifyAccount = () => {
    this.setState({
      status: {
        isValid: false,
        text: StoreStatus.UNVERIFIED,
      },
    });
  };

  handleDeleteAccount = () => {};

  copyPassword = (e: any) => {
    if (e) {
      navigator.clipboard.writeText(e);
      this.setState({
        showPassword: true,
      });
    }
  };

  showVerifyUserModal = () => {
    this.setState({
      verifyModal: !this.state.verifyModal,
    });
  };
  handleVerifiedAccount = () => {
    this.setState({
      status: {
        isValid: true,
        text: StoreStatus.ACTIVE,
      },
    });
    this.showVerifyUserModal();
  };
  renderVerifyUser = () => {
    return (
      <>
        <p>Are you sure you want to verify this account?</p>
        <Row className="button-container">
          <Col lg="6">
            <ButtonComponent
              buttonClass="button-small btn btn-primary-outline"
              buttonText="Go back"
              onClickHandler={this.showVerifyUserModal}
            />
          </Col>
          <Col lg="6">
            <ButtonComponent
              buttonClass="button-small btn btn-primary verify-btn"
              buttonText="Verify"
              onClickHandler={this.handleVerifiedAccount}
            />
          </Col>
        </Row>
      </>
    );
  };
  handleSwitch = (e: any) => {
    const fieldId = e.target.id;
    this.setState({
      [fieldId]: e.target.checked,
    });
  };
  render() {
    const {
      customerName,
      phoneNumber,
      password,
      storeName,
      coOrdinates,
      address,
      status,
      showToaster,
      catchError,
      toastMessage,
      showPassword,
      cnicNumber,
      storeType,
      incomeTaxStatus,
      registrationType,
    } = this.state;
    const validateForm =
      customerName.length > 0 &&
      phoneNumber.length > 0 &&
      storeName.length > 0 &&
      coOrdinates.length > 0 &&
      address.length > 0;

    const { isEdit, customer, isLoading } = this.props;

    const customerId = isEdit
      ? customer && customer.id
        ? customer.id
        : ""
      : "";

    const memberSince = isEdit
      ? customer && customer.createdAt
        ? new Date(`${customer.createdAt}`).toDateString()
        : ""
      : "";

    const storeActiveOption = {
      id: "active",
      clickHandler: this.showVerifyUserModal,
      value: StoreStatus.ACTIVE,
      label: StoreStatus.ACTIVE,
    };

    const storeInActiveOption = {
      id: "inactive",
      clickHandler: this.deactivateAccount,
      value: StoreStatus.INACTIVE,
      label: StoreStatus.INACTIVE,
    };

    const storeSuspendedOption = {
      id: "suspend",
      clickHandler: this.suspendAccount,
      value: StoreStatus.SUSPENDED,
      label: StoreStatus.SUSPENDED,
    };

    const storeUnverifiedOption = {
      id: "unverified",
      clickHandler: this.unverifyAccount,
      value: StoreStatus.UNVERIFIED,
      label: StoreStatus.UNVERIFIED,
    };

    const storeStatusOptions = [
      {
        id: "default",
        value: this.state.status.text,
        label: this.state.status.text,
        clickHandler: () => {},
      },
    ];
    if (status.isValid) {
      storeStatusOptions.push(storeInActiveOption, storeSuspendedOption);
    } else if (status.isValid === false && status.text === "INACTIVE") {
      storeStatusOptions.push(storeActiveOption);
    } else if (status.isValid === false && status.text === "UNVERIFIED") {
      storeStatusOptions.push(
        storeActiveOption,
        storeInActiveOption,
        storeSuspendedOption
      );
    } else if (status.isValid === false && status.text === "PENDING") {
      storeStatusOptions.push(
        storeActiveOption,
        storeInActiveOption,
        storeUnverifiedOption,
        storeSuspendedOption
      );
    } else if (status.isValid === false && status.text === "SUSPENDED") {
      storeStatusOptions.push(storeActiveOption);
    }

    const buttonText = isEdit ? "Update details" : "Create account";

    const isVisible =
      isEdit && this.context.can("update", "store")
        ? true
        : !isEdit && this.context.can("create", "store")
        ? true
        : false;

    const headingText = isEdit ? "Customer details" : "Add customer";

    const statusBadge =
      (status.text === "ACTIVE" && null) ||
      status.text === "INACTIVE" ||
      status.text === "SUSPENDED" ||
      status.text === "UNVERIFIED";

    // const isPhoneNumberDisabled = isEdit || this.isCustomerFound ? true : false;

    return (
      <div>
        <Modal
          showModal={this.state.verifyModal}
          closeModalHandler={this.showVerifyUserModal}
          modalHeading="Verify account"
          showProgressString={false}
          failedRecords=""
          modalBodyClass="verify-account"
        >
          {this.renderVerifyUser()}
        </Modal>

        <Modal
          showModal={this.state.resetPasswordModal}
          closeModalHandler={this.resetPasswordConfirmationModal}
          modalHeading="Change password"
          showProgressString={false}
          failedRecords=""
          modalBodyClass="verify-account"
        >
          {
            <>
              <p>Are you sure you want to change the password?</p>
              <Row>
                <Col className="col-lg-5">
                  <ButtonComponent
                    buttonClass="button-full btn btn-primary-outline"
                    buttonText="Go back"
                    onClickHandler={this.resetPasswordConfirmationModal}
                  />
                </Col>
                <Col className="col-lg-7 no-padding-left">
                  <ButtonComponent
                    buttonClass="button-full btn btn-primary"
                    buttonText="Change Password"
                    onClickHandler={this.resetPassword}
                  />
                </Col>
              </Row>
            </>
          }
        </Modal>

        {isLoading || (this.state.isLoading && <LoaderComponent />)}
        <Toaster
          showToaster={showToaster}
          toasterClass={
            catchError
              ? "toaster toaster-bg-danger"
              : "toaster toaster-bg-success"
          }
        >
          {toastMessage || ""}
        </Toaster>

        <Toaster
          showToaster={showPassword}
          toasterClass="toaster toaster-bg-success"
        >
          Password Copied
        </Toaster>

        <Container fluid>
          <Row>
            <Col>
              <div className="back-button">
                <a href="javascript:void(0)" onClick={this.handleGoBackButton}>
                  {" "}
                  {/* TO-DO: Convert this to a button in all compoents. */}
                  <span>
                    <img src={backarrow} alt="close" />
                  </span>{" "}
                  Back to Customers
                </a>
              </div>
              <HeadingText text={headingText} isMainHeading={true} />
            </Col>
            <Col>
              {isEdit && (
                <section className="member-created">
                  {statusBadge && (
                    <div className="status-badge">{statusBadge}</div>
                  )}
                  {memberSince && <span>Member since {memberSince}</span>}
                  <div className="customer-id">{customerId}</div>
                </section>
              )}
            </Col>
          </Row>
          <Row className="form-container">
            <Col xs="12">
              <Form name="customer-add-update-form">
                <div className="account-detail">
                  <FormSectionLayout subTitleText="Account details">
                    {/*<section className="form-group search-container">*/}
                    {/*  <label className="block text-uppercase label">*/}
                    {/*    Search for a user*/}
                    {/*  </label>*/}
                    {/*  <AsyncSelectComponent*/}
                    {/*      id="customerSearchSelect"*/}
                    {/*      placeHolderText="Search by phone number or shop name"*/}
                    {/*      handleAsyncSelectChange={this.handleAsyncSelectChange}*/}
                    {/*      loadAsyncOptions={this.handleSearchInputChange}*/}
                    {/*      isCustomSelectValue={true}*/}
                    {/*      // isDisabled={props.isEdit}*/}
                    {/*  />*/}
                    {/*</section>*/}
                    <TextField
                      id="customerName"
                      label="Customer Name"
                      placeholder="e.g. Bill Gates"
                      value={customerName}
                      handleChange={this.handleChange}
                      error={alphaNumericValidator(customerName)}
                      disabled={this.isCustomerFound}
                    />
                    <TextField
                      id="phoneNumber"
                      label="Phone Number"
                      placeholder="e.g. 03421231231"
                      value={phoneNumber}
                      handleChange={this.handleChange}
                      validator={phoneNumberValidate}
                      error={phoneNumberOnlyValidator(phoneNumber)}
                      disabled={true}
                    />
                    <TextField
                      id="cnicNumber"
                      label="CNIC Number"
                      placeholder="e.g. 11111-1111111-1"
                      value={cnicNumber}
                      handleChange={this.handleCnic}
                      validator={cnicNumberValidate}
                      maxLength={15}
                      error={cnicNumberOnlyValidator(cnicNumber)}
                      isOptional={true}
                      disabled={this.isCustomerFound}
                    />
                    <Switch
                      value={registrationType}
                      id="registrationType"
                      label="Registration Type"
                      checked={registrationType}
                      handleSwitch={this.handleSwitch}
                      statusVal1="Registered"
                      statusVal2="Unregistered"
                    />
                    <Switch
                      value={incomeTaxStatus}
                      id="incomeTaxStatus"
                      label="Income Tax Status"
                      checked={incomeTaxStatus}
                      handleSwitch={this.handleSwitch}
                      statusVal1="Active Filer"
                      statusVal2="Inactive Filer"
                    />
                    <div className={isEdit ? "form-row" : ""}>
                      <Col>
                        {isEdit && this.context.can("update", "password") && (
                          <ButtonComponent
                            buttonClass="btn btn-primary-outline button-large reset-button"
                            buttonText="Reset password"
                            onClickHandler={this.resetPasswordConfirmationModal}
                          />
                        )}
                      </Col>
                    </div>
                  </FormSectionLayout>
                </div>
                <div className="form-row-separator">
                  <FormSectionLayout subTitleText="Store details">
                    <TextField
                      id="storeName"
                      label="Store Name"
                      placeholder="e.g. Apple HQ General store"
                      value={storeName}
                      handleChange={this.handleChange}
                      error={alphaNumericValidator(storeName)}
                    />
                    <SearchableSelect
                      id="storeType"
                      isSearchable={true}
                      options={this.props.storeType}
                      onChange={(e: any) => {
                        this.handleSearchableSelect(e, "storeType");
                      }}
                      label="Store type"
                      placeholder="Store type"
                      selectedValue={this.selectedValue(
                        this.props.storeType,
                        storeType
                      )}
                    />

                    <TextField
                      id="coOrdinates"
                      label="Co-Ordinates"
                      placeholder="e.g. 24.887935, 67.054739"
                      value={coOrdinates}
                      handleChange={this.handleChange}
                      error={coordinateOnlyValidator(coOrdinates)}
                    />
                    <TextField
                      id="address"
                      label="Address"
                      placeholder="e.g. 23 A/15, FL 12, F-B Area, Karachi"
                      value={address}
                      handleChange={this.handleChange}
                      error={alphaNumericValidator(address)}
                    />
                    {isEdit && this.context.can("update", "store") && (
                      <SearchableSelect
                        id="storeStatus"
                        isSearchable={true}
                        options={storeStatusOptions}
                        onChange={(e: any) => {
                          this.storeStatusOnChange(e, "storeStatus");
                        }}
                        label="Store Status"
                        placeholder="Store Status"
                        selectedValue={this.selectedValue(
                          storeStatusOptions,
                          this.state.status.text
                        )}
                      />
                    )}
                    <div className="form-row-separator">
                      <Row>
                        {isVisible && (
                          <ButtonComponent
                            buttonClass="large-button btn-primary ml-3"
                            buttonText={buttonText}
                            onClickHandler={this.handleSubmit}
                            isDisable={this.props.isLoading || !validateForm}
                          />
                        )}
                      </Row>
                    </div>
                  </FormSectionLayout>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

AddUpdateCustomerPage.contextType = AbilityContext;
